// Vendor

require('babel-polyfill');

require('smallilies');
// require('lodash');
// require('moment');

require('jquery');
require('jquery-ui');
require('bootstrap-webpack');
require('angular');
require('angular-animate');
require('angular-sanitize');
require('angular-moment');
require('angular-storage');
require('angular-touch');
require('angular-translate');
require('ion-sound');
require('socket.io-client');

require('angular-ui-utils');
